import store from '@/store'
export default [
  {
    path: '/receipts',
    name: 'receipt',
    meta: { requiresAuth: true },
    component: () => import('@/pages/receipt/index.vue')
  },
  {
    path: '/receipts/create',
    name: 'receipt-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/receipt/create.vue')
  }
]
